import { useRef, useState } from "react";
import "./ResponseNavigate.css";
import { iconPath } from "effno-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";
import { ICONS } from "../shared/media";
import { Branding } from "../form-widgets/Branding";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp, CircleCheck } from "lucide-react";
import { NEXT_BUTTON } from "./ResponseContent";
 
type ResponseNavigateProps = {
    center?: boolean;
    showArrows?: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode?: boolean;
    buttonText?: string;
    allowEnter?: boolean;
    onSubmit?: () => void;
    onNext?: () => void;
    onPrev?: () => void;
}

export const ResponseNavigate = ({
    showArrows = true,
    center = false,
    isMobileLayout,
    isLastQuestion,
    commentMode = false,
    buttonText = NEXT_BUTTON,
    allowEnter = false,
    onSubmit,
    onNext,
    onPrev
    } : ResponseNavigateProps) => {

    const storeUser = useSelector(selectUser);

    const buttonRef = useRef(null)

    const flashAndSubmit = () => {
        const button = buttonRef.current as any;

        if (button) {
            button.style.animation = "animate-zoom 0.25s infinite";
    
            // Stop animation after 3 seconds (optional)
            setTimeout(() => {
                button.style.animation = "";

                if (onSubmit) {
                    onSubmit();
                }

            }, 250);
        }
    }

    console.log("[ResponseNavigate] onNext: ", onNext);

    return (
        <>
            {isMobileLayout &&
                <div className="response-content-mobile-footer-wrapper">
                    <div className="response-content-mobile-footer">
                        
                        {onPrev &&
                            <div 
                                className="response-navigate-button"
                                data-testid="response-navigate-prev"
                                onClick={onPrev}
                            >
                                    <ChevronLeft 
                                        size={20}
                                        color="var(--ftButtonTextColor)"
                                    />
                                
                            </div>
                        }
                       
                        <button
                            className="response-content-button-submit-mobile"
                            ref={buttonRef}
                            onClick={flashAndSubmit}
                            data-testid="response-content-submit"
                        >
                            {isLastQuestion && 
                                <div className="response-navigate-submit">
                                    <span>Submit</span><CircleCheck size={16}/>
                                </div>
                            }
                            {!isLastQuestion &&
                                <span>{buttonText}</span>
                            }
                        </button>

                        {onNext &&
                            <div 
                                className="response-navigate-button"
                                data-testid="response-navigate-next"
                                onClick={onNext}
                            >
                                    <ChevronRight 
                                        size={20}
                                        color="var(--ftButtonTextColor)"
                                    />                
                                
                            </div>
                        }                      
                    </div>

                    <div 
                        className="response-content-mobile-footer-branding"
                        onClick={() => window.open("https://effno.co", "_blank")}
                    >
                        Powered by&nbsp;<b>effno</b>
                    </div>
                </div>
            }
            {!isMobileLayout &&
                <>
                    {onNext &&
                        <div 
                            className="response-content-submit" 
                            style={{
                                ...(center ? {justifyContent: "center"} : {}),
                            }}
                        >
                            <button
                                className="response-content-button-submit"
                                ref={buttonRef}
                                onClick={flashAndSubmit}
                                data-testid="response-content-submit"
                            >
                                {isLastQuestion && 
                                    <div className="response-navigate-submit">
                                        <span>Submit</span><CircleCheck size={16}/>
                                    </div>
                                }
                                {!isLastQuestion &&
                                    <span>{buttonText}</span>
                                }
                            </button>

                            {allowEnter &&
                                <div className="response-content-enter">
                                    <span>press Enter ↵</span>
                                </div>
                            }
                        </div>
                    }
                    
                    <div 
                        className="response-navigate"
                        style={{
                            ...(isMobileLayout ? {position: "unset"} : {"position": "fixed"}),
                            // ...(commentMode ? {pointerEvents: "none"} : {})
                        }}
                    >
                        {showArrows &&
                            <>
                                
                                <div 
                                    className={onPrev ? "response-navigate-button" : "response-navigate-button-disabled"}
                                    data-testid="response-navigate-prev"
                                    onClick={onPrev}
                                >
                                        <ChevronUp 
                                            size={20}
                                            color="var(--ftButtonTextColor)"
                                        />
                                    
                                </div>
                                <div 
                                    className={onNext ? "response-navigate-button" : "response-navigate-button-disabled"}
                                    data-testid="response-navigate-next"
                                    onClick={onNext}
                                >
                                        <ChevronDown 
                                            size={20}
                                            color="var(--ftButtonTextColor)"
                                        />                
                                    
                                </div>
                            </>
                        }

                        <Branding />
                    </div>
                </>
            }
        </>
    )
}